import { render } from "./WorkPage.vue?vue&type=template&id=90fff8d0&scoped=true"
import script from "./WorkPage.vue?vue&type=script&lang=js"
export * from "./WorkPage.vue?vue&type=script&lang=js"

import "./WorkPage.vue?vue&type=style&index=0&id=90fff8d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90fff8d0"]])

export default __exports__